import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitPendingActions = createSelector(
  [selectFinancialCockpitState],
  ({ pendingActions }) => pendingActions
)
